<app-instance-info-section></app-instance-info-section>
<div class="row">
    <div class="col-md-3">
        <app-instance-configuration-sidebar
            [allowedItem]="allowedItem"
            (allowedItemType)="allowedItemTypeHandler($event)"
            (clickItem)="allowedItemHandler($event)"
        ></app-instance-configuration-sidebar>
    </div>
    <div class="col-md-9">
        <span>
            <app-instance-configuration-data
                [allowedItem]="selectedAllowedItemList"
                [breadcrumbData]="breadcrumbData"
                (selectAllClicked)="selectAllToggle()"
                (dataChangeEvent)="dataChangeEventHandler($event)"
                [selectAll]="selectAll"
                (allowedItemBreadCrumbClicked)="allowedItemBreadCrumbClickedHandler($event)"
            ></app-instance-configuration-data>
        </span>
    </div>
</div>
